import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Link from '../../../base/Link';
import { getColorForName } from '../../../theme/colors';

export const ListItemStyled = styled.li`
  margin-bottom: ${rem(10)};
`;

export const LinkStyled = styled(Link)`
  color: ${getColorForName('color-neutral-gray-29')};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`;
